import React from 'react'
import { useSelector } from 'react-redux'
import { text } from '@groovehq/internal-design-system/lib/styles/elements'
import { selectAccountPreferenceHideReporting } from 'selectors/app/selectAccountPreferences'
import { selectCurrentUserIsOwner } from 'ducks/currentUser'
import AutomateSection from './AutomateSection'
import CentralizeSection from './CentralizeSection'
import AnalyzeSection from './AnalyzeSection'
import IntegrationsSection from './IntegrationsSection'
import LearnSection from './LearnSection'
import { styles } from './styles'

const Nav = ({ className, active }) => {
  const hideReporting = useSelector(selectAccountPreferenceHideReporting)
  const currentUserIsOwner = useSelector(selectCurrentUserIsOwner)
  const showReporting = currentUserIsOwner || !hideReporting

  return (
    <nav className={className}>
      <div
        css={[text.styles.fontMedium, styles.list]}
        className="grui flex items-center"
      >
        <CentralizeSection css={styles.item} active={active} />
        <AutomateSection css={styles.item} active={active} />
        {showReporting && <AnalyzeSection css={styles.item} active={active} />}
        <IntegrationsSection css={styles.item} />
        <LearnSection css={styles.item} />
      </div>
    </nav>
  )
}

export default Nav
